import { atom } from 'recoil';

export const windowState = atom({
  key: 'windowState',
  default: {
    isMobile: false,
    isTablet: false
  }
});